@if (control$ | async; as control) {
    @if (control.touched) {
        <app-validation-popover [resetOn]="control.value">
            <!--
                VALIDATION MESSAGE PRIORITY ORDER
                =================================
                Uses @if/@else if chains to show only ONE validation message at a time.
                Order matters when multiple validators fail simultaneously.

                PRIORITY: Required → Type/Format → Range/Constraint → Business logic

                RATIONALE:
                Type/format validators should return null for empty values (using isEmptyInputValue).
                This ensures 'required' and type errors don't both trigger for empty input.
                If both errors exist (edge case), 'required' takes priority as it's more fundamental.

                MAINTENANCE: Keep 'required' validator first. Test only one message shows.
            -->
            @if (control.hasError('required')) {
                <div>
                    {{
                        'control-messages_FIELD_IS_REQUIRED'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('numberCheck')) {
                <div>
                    {{
                        'control-messages_VALUE_MUST_BE_NUMBER'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('integer')) {
                <div>
                    {{
                        'control-messages_VALUE_MUST_BE_INTEGER'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('pattern')) {
                <div>
                    {{
                        'control-messages_INVALID_FORMAT'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('preciseNumber')) {
                <div>
                    {{
                        (
                            'control-messages_INVALID_FOR_PRECISE_NUMBER_MIN_0'
                            | translate: 'common' : 'brunata-angular-ui'
                        )
                            .replace('{1}', control.errors?.['preciseNumber'].digits)
                            .replace('{2}', control.errors?.['preciseNumber'].decimals)
                    }}
                </div>
            } @else if (control.hasError('checkAplhabeticString')) {
                <div>
                    {{
                        'control-messages_VALUE_MUST_BE_STRING'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('min')) {
                <div>
                    {{
                        (
                            'control-messages_VALUE_IS_TOO_LOW'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['min'].min)
                    }}
                </div>
            } @else if (control.hasError('max')) {
                <div>
                    {{
                        (
                            'control-messages_VALUE_IS_TOO_HIGH'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['max'].max)
                    }}
                </div>
            } @else if (control.hasError('maxlength')) {
                <div>
                    {{
                        (
                            'control-messages_the_entered_value_is_too_long'
                            | translate: 'common' : 'brunata-angular-ui'
                        )
                            .replace('{1}', control.errors?.['maxlength'].requiredLength)
                            .replace('{2}', control.errors?.['maxlength'].actualLength)
                    }}
                </div>
            } @else if (control.hasError('minlength')) {
                <div>
                    {{
                        (
                            'control-messages_the_entered_value_is_too_short'
                            | translate: 'common' : 'brunata-angular-ui'
                        )
                            .replace('{1}', control.errors?.['minlength'].requiredLength)
                            .replace('{2}', control.errors?.['minlength'].actualLength)
                    }}
                </div>
            } @else if (control.hasError('minDate')) {
                <div>
                    {{
                        (
                            'control-messages_DATE_IS_TOO_EARLY'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['minDate'].min | appdate)
                    }}
                </div>
            } @else if (control.hasError('maxDate')) {
                <div>
                    {{
                        (
                            'control-messages_DATE_IS_TOO_LATE'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['maxDate'].max | appdate)
                    }}
                </div>
            } @else if (control.hasError('postalCode')) {
                <div>
                    {{
                        'control-messages_CONTRYCODE_POSTALCODE_DOES_NOT_EXIST'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('postalCodeExists')) {
                <div>
                    {{
                        'control-messages_POSTALCODE_EXISTS'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('email')) {
                <div>
                    {{
                        'control-messages_INVALID_EMAIL'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('ngbDate')) {
                <div>
                    {{
                        (
                            'control-messages_INVALID_DATE_VALUE'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['ngbDate'].invalid)
                    }}
                </div>
            } @else if (control.hasError('brunataNoUnique')) {
                <div>
                    {{
                        'control-messages_BRUNATA_NO_MUST_BE_UNIQUE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('locationNoUnique')) {
                <div>
                    {{
                        'control-messages_LOCATION_NO_MUST_BE_UNIQUE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('startDateAfterEndDate')) {
                <div>
                    {{
                        'control-messages_STARTDATE_GREATER_THAN_ENDDATE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('dateIsUsed')) {
                <div>
                    {{
                        'control-messages_SET_UNIUQE_DATE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('overlaps')) {
                <div>
                    {{
                        'control-messages_OVERLAPPING_VALUES'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('dateRangeOverlap')) {
                <div>
                    {{
                        'control-messages_OVERLAPPING_PERIODS'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('meterIsUnAvailable')) {
                <div>
                    {{
                        'control-messages_COLLIDING_AUX_METERS'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('channelIsUnAvailable')) {
                <div>
                    {{
                        'control-messages_COLLIDING_CHANNEL'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('alloPercentageError')) {
                <div>
                    {{
                        (
                            'control-messages_ALLOCATION_PERCENT_ERROR_2'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['alloPercentageError'] | appnumber)
                    }}
                </div>
            } @else if (control.hasError('poolPercentageError')) {
                <div>
                    {{
                        (
                            'control-messages_POOL_PERCENT_ERROR_2'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['poolPercentageError'] | appnumber)
                    }}
                </div>
            } @else if (control.hasError('buildingTaxIdError')) {
                <div>
                    {{
                        'control-messages_BUILDING_TAXID_DUPLICATE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('taxUnique')) {
                <div>
                    {{
                        'control-messages_TAX_NAME_MUST_BE_UNIQUE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('consumerCategoriesError')) {
                <div>
                    {{
                        'control-messages_CONSUMER_CATEGORY_DUPLICATE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('consumerCategoriesNumberError')) {
                <div>
                    {{
                        'control-messages_CONSUMER_CATEGORY_NUMBER_DUPLICATE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('buildingAlloUnitUnique')) {
                <div>
                    {{
                        'control-messages_ALLOCATION_FIGURES_MUST_BE_UNIQUE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('locationAlloUnit')) {
                <div>
                    {{
                        'control-messages_FIXED_ALLOCATION_FIGURE_UNIQUE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('amountExeeds100')) {
                <div>
                    {{
                        'control-messages_COST_SUMMED_PERCENTAGE_EXEEDS_100'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('differentErpSystem')) {
                <div>
                    {{
                        'control-messages_DIFFERENT_ERP_SYSTEM'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('oddMoveDate')) {
                <div>
                    {{
                        'control-messages_ODDMOVEDATE' | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('formatAsDdMmErr')) {
                <div>
                    {{
                        'control-messages_PERIOD_END_DATE_VALIDATOR_FORMAT'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('sameDate')) {
                <div>
                    {{
                        'control-messages_SAMEMOVEINDATE'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('applicationExist')) {
                <div>
                    {{
                        (
                            'control-messages_WEBLANG_APPLICATION_EXIST'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.value)
                    }}
                </div>
            } @else if (control.hasError('moduleExists')) {
                <div>
                    {{
                        (
                            'control-messages_WEBLANG_MODULE_EXIST'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.value)
                    }}
                </div>
            } @else if (control.hasError('viewExists')) {
                <div>
                    {{
                        (
                            'control-messages_WEBLANG_VIEW_EXIST'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.value)
                    }}
                </div>
            } @else if (control.hasError('keyExists')) {
                <div>
                    {{
                        (
                            'control-messages_WEBLANG_KEY_EXIST'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.value)
                    }}
                </div>
            } @else if (control.hasError('initialsAlreadyExists')) {
                <div>
                    {{
                        (
                            'control-messages_USERADMINISTRATION_INITIAL_EXIST'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.value)
                    }}
                </div>
            } @else if (control.hasError('invalidMonthYear')) {
                <div>
                    {{
                        (
                            'control-messages_INVALIDMONTHYEARFORMATTING'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.errors?.['invalidMonthYear'])
                    }}
                </div>
            } @else if (control.hasError('duplicateAccountNo')) {
                <div>
                    {{
                        (
                            'control-messages_DUPLICATE_ACCOUNTNO'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{0}', control.value)
                    }}
                </div>
            } @else if (control.hasError('allocateTotalAmountPaticipantParOfAllocation')) {
                <div>
                    {{
                        'control-messages_PATICIPANT_PART_OF_ALLOCATION_ALLOCATE_TOTAL_AMOUNT_VALID'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('duplicateApiTokenName')) {
                <div>
                    {{
                        'control-messages_ERRORS_DUPLICATE_TOKEN_NAME'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('endDateIsBeforeStartDate')) {
                <div>
                    {{
                        (
                            'control-messages_END_DATE_IS_BEFORE_START_DATE'
                            | translate: 'common' : 'brunata-angular-ui'
                        ).replace('{1}', control.errors?.['endDateIsBeforeStartDate'].min | appdate)
                    }}
                </div>
            } @else if (control.hasError('customValidationMessage')) {
                <div>
                    {{ control.errors?.['customValidationMessage'] }}
                </div>
            } @else if (control.hasError('atLeastOneErrorMeter')) {
                <div>
                    {{
                        'control-messages_AT_LEAST_ONE_METER_SELECTION'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('atLeastOneErrorUsage')) {
                <div>
                    {{
                        'control-messages_AT_LEAST_ONE_USAGE_UNIT_SELECTION'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('periodBetween')) {
                <div>
                    {{
                        (
                            'control-messages_PERIOD_MUST_BE_BETWEEN'
                            | translate: 'common' : 'brunata-angular-ui'
                        )
                            .replace('{0}', control.errors?.['periodBetween'].min)
                            .replace('{1}', control.errors?.['periodBetween'].max)
                    }}
                </div>
            } @else if (control.hasError('hourlyPeriodBetween')) {
                <div>
                    {{
                        ('validation_HOURLY_PERIOD_MUST_BE_BETWEEN' | translate)
                            .replace('{0}', control.errors?.['hourlyPeriodBetween'].min)
                            .replace('{1}', control.errors?.['hourlyPeriodBetween'].max)
                    }}
                </div>
            } @else if (control.hasError('atLeastOneMeterSelected')) {
                <div>
                    {{ 'validation_AT_LEAST_ONE_METER_SELECTION' | translate }}
                </div>
            } @else if (control.hasError('atLeastOneUsageUnit')) {
                <div>
                    {{ 'validation_AT_LEAST_ONE_USAGE_UNIT_SELECTION' | translate }}
                </div>
            } @else if (control.hasError('meterWithWrongUsageSelected')) {
                <div>
                    {{
                        'control-messages_meters-with-wrong-usageunit-in-selection'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('noVendorModelSelected')) {
                <div>
                    {{
                        'control-messages_AT_LEAST_ONE_VENDOR_MODEL_SELECTION'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('duplicateFileHeader')) {
                <div>
                    {{
                        'control-messages_DUPLICATED_FILE_HEADER_IN_IMPORT'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('fileAlreadyExists')) {
                <div>
                    {{
                        'control-messages_file_already_exists'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('folderAlreadyExists')) {
                <div>
                    {{
                        'control-messages_folder_already_exists'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('forbiddenChars')) {
                <div>
                    {{
                        'control-messages_forbidden_chars'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                    {{ control.errors?.['forbiddenChars'].chars }}
                </div>
            } @else if (control.hasError('noDataSourceSelected')) {
                <div>
                    {{
                        'control-messages_NO_OPTION_SELECTED'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                    {{ control.errors?.['noDataSourceSelected'].chars }}
                </div>
            } @else if (control.hasError('invalidHex')) {
                <div>
                    {{
                        'control-messages_invalid_hex' | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            } @else if (control.hasError('invalidPhoneNumber')) {
                <div>
                    {{
                        'control-messages_invalid_phone_number'
                            | translate: 'common' : 'brunata-angular-ui'
                    }}
                </div>
            }
        </app-validation-popover>
    }
}
